export default "__VITE_ASSET__CUwjUFMU__"